import styled from "styled-components";
import { COLORS } from "../../../../../../../assets/constants/styles";

export const MessageBlock = styled.div`
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background-color: ${COLORS.white};
  border: 2px solid
    ${(props) =>
      props.role === "developer" ? COLORS.violet : COLORS.lightGrey};
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
`;

export const MessageHeader = styled.div`
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 14px;
  color: ${COLORS.grey};
`;

export const MessageContent = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 1.5;
  max-width: 100%;
`;
